import React from "react";
import { Button, Modal } from "react-bootstrap";
import { HelpOutline } from '@material-ui/icons';

/**
 * @desc created pure component for open delete prompt
 */
class DeletePrompt extends React.Component {
  
    render() {

      return (        
        <Modal
          show={this.props.deletePrompt}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400 modal-delete"
          centered
          backdrop={false}>
    
          <Modal.Body className="pb-0 text-center">
              <HelpOutline />
              <p>Are you sure you want to delete?</p>
          </Modal.Body>
          <Modal.Footer>
              <Button variant='primary' className="btn-blue btn-outlined w-140" onClick={() => { this.props.cancel() }}>Cancel</Button>
              <Button variant='primary' className="btn-blue w-140" onClick={() => { this.props.deleteConfirm(this.props.itemId) }}>Yes</Button>
          </Modal.Footer>
      </Modal>
      )
    }
}

export default DeletePrompt;